/**
 *
 * Cookie Indication
 * if Cooke "merkliste" exist, highlight Element( a heart in metanavigation)
 *
 * And ClickEvent for all .favorite (Herz) Symbols. If one is Clicked, highlight Element
 *
 */

class CookieIndication {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        const CookieIndicator = this.elem;

        // in date-name cookiename is located:
        const CookieIndicatorName = this.elem.getAttribute('data-name');
        const favorite = document.querySelectorAll('.favorite');

        function getCookie(name) {
            const dc = document.cookie;
            const prefix = name + "=";
            let begin = dc.indexOf("; " + prefix);
            let end;
            if (begin === -1) {
                begin = dc.indexOf(prefix);
                if (begin !== 0) return null;
            }
            else {
                begin += 2;
                end = document.cookie.indexOf(";", begin);
                if (end === -1) {
                    end = dc.length;
                }
            }
            return decodeURI(dc.substring(begin + prefix.length, end));
        }

        function highlightIndicator(hasCookie) {
            const myCookie = getCookie(hasCookie);

            if (myCookie !== null) {
                CookieIndicator.classList.add('cookie-indication--active');
            }
        }

        highlightIndicator(CookieIndicatorName);


        // Click Event Handler for .favorite (Herz) Icons
        for (let i = 0; i < favorite.length; i++) {
            favorite[i].addEventListener('click', function() {
                CookieIndicator.classList.remove('cookie-indication--active');
                void CookieIndicator.offsetWidth;
                CookieIndicator.classList.add('cookie-indication--active');
            });
        }
    }
}

export default CookieIndication;
